import { IState } from "@redux/store.types";
import { getValueState } from "@redux/utils";

import {
    $FlyoutCategoriesModuleName,
    FlyoutCategory,
} from "./flyoutCategories.types";

const getFlyoutCategories = (state: IState) =>
    getValueState(state, $FlyoutCategoriesModuleName) as
        | FlyoutCategory
        | undefined;

export { getFlyoutCategories };
